// src/app/services/auth-error.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface AuthError {
  titulo: string;
  mensaje: string;
}

/**
 * Servicio para mostrar errores de autenticación usando modal-error
 * Permite que interceptores y guards muestren errores sin acceso directo a componentes
 */
@Injectable({
  providedIn: 'root'
})
export class AuthErrorService {
  private errorSubject = new Subject<AuthError>();
  public error$ = this.errorSubject.asObservable();

  /**
   * Muestra un error de autenticación
   */
  showError(titulo: string, mensaje: string): void {
    this.errorSubject.next({ titulo, mensaje });
  }

  /**
   * Muestra un error 401 (sesión expirada)
   */
  showSessionExpired(mensaje?: string): void {
    this.showError(
      'Sesión expirada',
      mensaje || 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.'
    );
  }

  /**
   * Muestra un error de token inválido
   */
  showInvalidToken(mensaje?: string): void {
    this.showError(
      'Error de autenticación',
      mensaje || 'Tu token de autenticación es inválido. Por favor, inicia sesión nuevamente.'
    );
  }

  /**
   * Muestra un error de conexión
   */
  showConnectionError(mensaje?: string): void {
    this.showError(
      'Error de conexión',
      mensaje || 'No se pudo conectar con el servidor. Verifica tu conexión a internet.'
    );
  }
}

